import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Redux States
import {
  GET_PRODUCT_DETAIL_LIST_REQUEST,
  GET_PRODUCT_DETAIL_LIST_BY_PRODUCT_CATEGORY_ID_REQUEST,
  ADD_PRODUCT_DETAIL_REQUEST,
  UPDATE_PRODUCT_DETAIL_BY_PRODUCT_DETAIL_ID_REQUEST,
  UPDATE_PRODUCT_DETAIL_STATUS_BY_PRODUCT_DETAIL_ID_REQUEST,
  DELETE_PRODUCT_DETAIL_BY_PRODUCT_DETAIL_ID_REQUEST,
  GET_PRODUCT_IMAGES_BY_PRODUCT_DETAIL_ID_REQUEST,
  UPDATE_PRODUCT_IMAGES_BY_PRODUCT_DETAIL_ID_REQUEST,
  DELETE_PRODUCT_IMAGES_BY_PRODUCT_DETAIL_ID_REQUEST,
  SET_DEFAULT_IMAGE_FOR_PRODUCT_DETAIL_REQUEST,
} from "./actionTypes";
import {
  updateProductDetailStatusByProductDetailIdResponse,
  getProductDetailListResponse,
  getProductDetailListByProductCategoryIdResponse,
  addProductDetailResponse,
  updateProductDetailByProductDetailIdResponse,
  deleteProductDetailByProductDetailIdResponse,
  getProductImagesByProductDetailIdResponse,
  updateProductImagesByProductDetailIdResponse,
  deleteProductImagesByProductDetailIdResponse,
  setDefaultImageForProductDetailResponse,
} from "./actions";
import { invokeApi } from "helpers/axiosHelper";
import { handleApiCallException } from "store/Shared/actions";

function* getProductDetailList() {
  try {
    const response = yield call(invokeApi, "get", "/ProductDetail", "");
    yield put(getProductDetailListResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* getProductDetailListByProductCategoryId({
  payload: { productCategoryId },
}) {
  try {
    const response = yield call(
      invokeApi,
      "get",
      "/ProductDetail/GetProductListByProductCategoryId/" + productCategoryId,
      ""
    );
    yield put(getProductDetailListByProductCategoryIdResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* addProductDetail({ payload: { data } }) {
  try {
    const response = yield call(invokeApi, "post", "/ProductDetail", data);
    // if (response.isSuccessResponse) {
    //     yield put(getProductDetailListRequest());
    // }
    yield put(addProductDetailResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* updateProductDetailByProductDetailId({
  payload: { productDetailId, data },
}) {
  try {
    const response = yield call(
      invokeApi,
      "put",
      "/ProductDetail/" + productDetailId,
      data
    );
    yield put(updateProductDetailByProductDetailIdResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* deleteProductDetailByProductDetailId({
  payload: { productDetailId },
}) {
  try {
    const response = yield call(
      invokeApi,
      "delete",
      "/ProductDetail/" + productDetailId
    );
    yield put(deleteProductDetailByProductDetailIdResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* updateProductDetailStatusByProductDetailId({
  payload: { productDetailId, status },
}) {
  try {
    const response = yield call(
      invokeApi,
      "patch",
      "/ProductDetail/" + productDetailId + "/" + status
    );
    yield put(updateProductDetailStatusByProductDetailIdResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* getProductImagesByProductDetailId({ payload: { productDetailId } }) {
  try {
    const response = yield call(
      invokeApi,
      "get",
      "/ProductDetail/GetProdutImagesById/" + productDetailId
    );
    yield put(getProductImagesByProductDetailIdResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* updateProductImagesByProductDetailId({
  payload: { productDetailId, data },
}) {
  try {
    const response = yield call(
      invokeApi,
      "put",
      "/ProductDetail/UpdateProductImagesById/" + productDetailId,
      data
    );
    yield put(updateProductImagesByProductDetailIdResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* deleteProductImagesByProductDetailId({
  payload: { productDetailId, data },
}) {
  try {
    const response = yield call(
      invokeApi,
      "put",
      "/ProductDetail/DeleteProdutImagesById/" + productDetailId,
      data
    );
    yield put(deleteProductImagesByProductDetailIdResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* setDefaultImageForProductDetail({
  payload: { productDetailId, productImageName },
}) {
  try {
    const response = yield call(
      invokeApi,
      "patch",
      "/ProductDetail/SetDefaultImgForProduct/" +
        productDetailId +
        "/" +
        productImageName
    );
    yield put(setDefaultImageForProductDetailResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

export function* watchProductDetail() {
  yield takeEvery(GET_PRODUCT_DETAIL_LIST_REQUEST, getProductDetailList);
  yield takeEvery(ADD_PRODUCT_DETAIL_REQUEST, addProductDetail);
  yield takeEvery(
    GET_PRODUCT_DETAIL_LIST_BY_PRODUCT_CATEGORY_ID_REQUEST,
    getProductDetailListByProductCategoryId
  );
  yield takeEvery(
    UPDATE_PRODUCT_DETAIL_BY_PRODUCT_DETAIL_ID_REQUEST,
    updateProductDetailByProductDetailId
  );
  yield takeEvery(
    DELETE_PRODUCT_DETAIL_BY_PRODUCT_DETAIL_ID_REQUEST,
    deleteProductDetailByProductDetailId
  );
  yield takeEvery(
    UPDATE_PRODUCT_DETAIL_STATUS_BY_PRODUCT_DETAIL_ID_REQUEST,
    updateProductDetailStatusByProductDetailId
  );

  yield takeEvery(
    GET_PRODUCT_IMAGES_BY_PRODUCT_DETAIL_ID_REQUEST,
    getProductImagesByProductDetailId
  );
  yield takeEvery(
    UPDATE_PRODUCT_IMAGES_BY_PRODUCT_DETAIL_ID_REQUEST,
    updateProductImagesByProductDetailId
  );
  yield takeEvery(
    DELETE_PRODUCT_IMAGES_BY_PRODUCT_DETAIL_ID_REQUEST,
    deleteProductImagesByProductDetailId
  );
  yield takeEvery(
    SET_DEFAULT_IMAGE_FOR_PRODUCT_DETAIL_REQUEST,
    setDefaultImageForProductDetail
  );
}

function* productDetailSaga() {
  yield all([fork(watchProductDetail)]);
}

export default productDetailSaga;
